import { render } from "./CustomTextQuery.vue?vue&type=template&id=28ea2592"
import script from "./CustomTextQuery.vue?vue&type=script&lang=js"
export * from "./CustomTextQuery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__